import React, { useCallback, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { CountBadge, HasOwnership } from "components/common";
import EntityShareModal from "components/permissions/EntityShareModal";
import { COLLECTIONS_QUERY_KEY } from "collections/hooks/useCollections";
import { useTranslation } from "react-i18next";
const SharedWithCell = ({ shared_with, id, title }) => {
  const { t } = useTranslation("enterprise_collections");
  const queryClient = useQueryClient();
  const [showEntityShareModal, setShowEntityShareModal] = useState(false);
  const refetchCollections = useCallback(
    () => queryClient.invalidateQueries({
      queryKey: [COLLECTIONS_QUERY_KEY]
    }),
    [queryClient]
  );
  const toggleEntityShareModal = () => setShowEntityShareModal(!showEntityShareModal);
  const handleShareClose = () => {
    refetchCollections();
    toggleEntityShareModal();
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(HasOwnership, { type: "collection_entities", id }, ({ disabled }) => /* @__PURE__ */ React.createElement(CountBadge, { onClick: disabled ? void 0 : toggleEntityShareModal, count: shared_with })), showEntityShareModal && /* @__PURE__ */ React.createElement(
    EntityShareModal,
    {
      entityId: id,
      entityType: "collection_entities",
      entityTypeTitle: t("shared.collection_content"),
      entityTitle: title,
      description: t("shared_with_cell.share_description"),
      onClose: handleShareClose
    }
  ));
};
export default SharedWithCell;
